import { logError } from 'derivita/omaha/base/logging';

let loggedDocumentAdoption = false;

export class ComponentElement extends HTMLElement {
  private constructedDoc?: Document;

  constructor(
    private onConnected?: () => void,
    private onDisconnected?: () => void
  ) {
    super();

    // Track the document at construction time to detect later adoption into another document.
    this.constructedDoc = this.ownerDocument;

    // Browser-initiated construction (e.g., innerHTML parsing) creates elements
    // without callbacks. This is expected and benign — lifecycle hooks no-op safely.
  }

  connectedCallback() {
    // Detect if the element was adopted into a different document before connecting.
    if (
      this.constructedDoc &&
      this.ownerDocument !== this.constructedDoc &&
      !loggedDocumentAdoption
    ) {
      loggedDocumentAdoption = true;
      const constructedWin = this.constructedDoc?.defaultView;
      const currentWin = this.ownerDocument?.defaultView;
      const details = {
        'kind': 'ComponentElementOwnerDocumentChanged',
        'constructedDocUrl': this.constructedDoc?.URL,
        'currentDocUrl': this.ownerDocument?.URL,
        'constructedWindowName': constructedWin?.name,
        'currentWindowName': currentWin?.name,
        'constructedLocationHref': constructedWin?.location?.href,
        'currentLocationHref': currentWin?.location?.href,
      };
      // Log breadcrumb-style details first so they are associated with the captured exception.
      // eslint-disable-next-line no-console
      console.log(details);
      const err = new Error(
        'ComponentElement ownerDocument changed between construction and connection'
      );
      try {
        logError(err);
      } catch {}
    }

    // If the callback is missing, no-op to avoid noisy errors.
    if (this.onConnected) {
      try {
        this.onConnected();
      } catch (e) {
        logError(e);
      }
    }
  }
  disconnectedCallback() {
    if (this.onDisconnected) {
      try {
        this.onDisconnected();
      } catch (e) {
        logError(e);
      }
    }
  }
}

customElements.define('d-div', ComponentElement);
